export default function getUpdateRecentlySearchedList(list, id) {
    if (list) {
        let updatedList = [...list];
        const index = updatedList.indexOf(id);
        if (index !== -1) {
            updatedList.splice(index, 1);
        }

        updatedList.unshift(id);

        if (updatedList?.length > 5) {
            updatedList = updatedList.slice(0, 5);
        }

        return updatedList;
    }
    return [];
}
